module.exports = __webpack_public_path__ + "735d56a498a221b8e66a093a61405274.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/war_has_a_price-1050.webp.png
// module id = 616
// module chunks = 0